import ColorMapHelper from "./ColorMapHelper";
import { isDefined, isTrue } from "../../shared/utils";
import { FILES, MAPSTYLES } from "../shared/index";
import Zernike from "../js/zernike";
import { drawSegment } from "./SmoothLine";
import FourierCalculate from "./FourierCalculate";
import fileSys from "../../fileoprators/fileSystem";

export default class GenReportMap {
  constructor(casePath, bgColor = 0xff2d3039) {
    this.casePath = casePath;
    this.zernike = new Zernike();
    this.bgColor = bgColor;
  }
  getMap(mapstyle, mapIndexInForm, ifCanvas = false) {
    let map = {
      mapURL: "",
      colorBarURL: "",
      params: []
    };
    let data;
    let zernikeInfo;
    let fourierInfo;
    if (mapstyle === MAPSTYLES.Zernike) {
      data = this.calcZernike(this.casePath);
      zernikeInfo = isDefined(data)
        ? { data: data.data, cntVal: data.cntVal, step: data.cmStep }
        : null;
    }
    if (mapstyle === "fourierAnalysis") {
      data = FourierCalculate.Calculate(fileSys.combinePath(this.casePath, FILES.cartSagf));
      let obj =
        mapIndexInForm === 0
          ? data.sph
          : mapIndexInForm === 1
            ? data.decent
            : mapIndexInForm === 3
              ? data.regular
              : mapIndexInForm === 4
                ? data.irregular
                : null;
      fourierInfo = isDefined(obj) ? obj : null;
      map.calParams = data.value;
    }
    let mapParams = {
      mapIndexInForm,
      mapIndex: mapstyle,
      casePath: this.casePath,
      colorBarSize: {
        width: 90,
        height: 600
      },
      zernikeInfo: zernikeInfo,
      fourierInfo: fourierInfo
    };
    let _mapObj = ColorMapHelper.getReportColorMap(mapParams, ifCanvas, this.bgColor);
    map.mapURL = isDefined(_mapObj) ? _mapObj.url : "";
    map.numVals = isDefined(_mapObj) ? _mapObj.numVals : null;
    map.minMaxVals = isDefined(_mapObj) ? _mapObj.minMaxVals : null;
    map.colorBarURL = isDefined(_mapObj) ? _mapObj.colorBarURL : "";
    map.size = isDefined(_mapObj) ? _mapObj.size : { width: 601, height: 601 };
    map.bmpData = isDefined(_mapObj) ? _mapObj.bmpData : null;
    map.ptr = isDefined(_mapObj) ? _mapObj.ptr : null;
    return map;
  }
  getDiffMap(mapParamsOne, mapParamsTwo, mapstyle, mapIndexInForm, ifCanvas = false) {
    let map = {
      mapURL: "",
      colorBarURL: "",
      params: []
    };
    let colorBarSize = {
      width: 90,
      height: 600
    };
    let _mapObjOne = ColorMapHelper.getDiffNormalColorMap(
      mapParamsOne.mapIndex,
      mapParamsOne.casePath,
      mapParamsOne.colorBarSize,
      "compare",
      ifCanvas,
      this.bgColor
    );
    let _mapObjTwo = ColorMapHelper.getDiffNormalColorMap(
      mapParamsTwo.mapIndex,
      mapParamsTwo.casePath,
      mapParamsTwo.colorBarSize,
      "compare",
      ifCanvas,
      this.bgColor
    );
    let ptrA = _mapObjOne && _mapObjOne.ptr ? _mapObjOne.ptr : null;
    let ptrB = _mapObjTwo && _mapObjTwo.ptr ? _mapObjTwo.ptr : null;
    let _mapObjDiff;
    if (isDefined(ptrA) && isDefined(ptrB))
      _mapObjDiff = ColorMapHelper.getDiffColorMap(
        ptrA,
        ptrB,
        colorBarSize,
        mapstyle,
        mapIndexInForm,
        ifCanvas,
        this.bgColor
      );
    map.mapURL = isDefined(_mapObjDiff) ? _mapObjDiff.url : "";
    map.numVals = isDefined(_mapObjDiff) ? _mapObjDiff.numVals : null;
    map.minMaxVals = isDefined(_mapObjDiff) ? _mapObjDiff.minMaxVals : null;
    map.colorBarURL = isDefined(_mapObjDiff) ? _mapObjDiff.colorBarURL : "";
    map.size = isDefined(_mapObjDiff) ? _mapObjDiff.size : { width: 601, height: 601 };
    map.bmpData = isDefined(_mapObjDiff) ? _mapObjDiff.bmpData : null;
    return map;
  }
  getZernikeImgs(chartW = 450, chartH = 310) {
    let map = {
      mapURL: "",
      colorBarURL: "",
      params: "" // 用于高度参数显示
    };
    let data;
    let zernikeInfo;
    data = this.calcZernike(this.casePath);

    zernikeInfo = isDefined(data)
      ? { data: data.data, cntVal: data.cntVal, step: data.cmStep }
      : null;
    let mapParams = {
      mapIndex: MAPSTYLES.Zernike,
      casePath: this.casePath,
      colorBarSize: {
        width: 100,
        height: 900
      },
      zernikeInfo: zernikeInfo
    };
    let _mapObj = ColorMapHelper.getReportColorMap(mapParams, false, this.bgColor);
    map.mapURL = isDefined(_mapObj) ? _mapObj.url : "";
    map.colorBarURL = isDefined(_mapObj) ? _mapObj.colorBarURL : "";
    map.numVals = isDefined(_mapObj) ? _mapObj.numVals : null;
    let retinal = {
      URL: data && data.psfInfo ? data.psfInfo.eUrl : "",
      title: `Retinal Image (${window.zernikeSet.diameter._toFixed(2)}mm pupil)`
    };
    let psf = {
      URL: data && data.psfInfo ? data.psfInfo.psfUrl : "",
      title: `PSF (${window.zernikeSet.diameter._toFixed(2)}mm pupil)`,
      label: data && data.psfInfo ? `Strehl ratio = ${data.psfInfo.ratio._toFixed(3)}` : "--"
    };
    let chart = {
      URL:
        data && data.psfInfo
          ? this.genChart(data.psfInfo.export0, data.psfInfo.export90, chartW, chartH)
          : "",
      title: `MTF (${window.zernikeSet.diameter._toFixed(2)}mm pupil)`
    };
    let { values, maxPeak, meanRms } = data || { values: [], maxPeak: -1000, meanRms: -1000 };
    map = { retinal, psf, chart, ...map, values, maxPeak, meanRms };

    return map;
  }
  calcZernike(casePath) {
    let result = this.zernike.initZernikeMod(casePath);
    if (!result) {
      this.free();
      return;
    }
    result = this.zernike.udateRpZnkOrder(window.zernikeSet.order, window.zernikeSet.diameter);
    if (!result) {
      this.free();
      return;
    }
    let indexes = this.getIndexes();
    result = this.zernike.calcZnkMap(indexes);
    let values = this.zernike.getUIParams();
    let maxPeak = this.zernike.getUIMaxXY();
    let meanRms = this.zernike.getUIZnkparaKeys(indexes);
    if (!result) {
      this.free();
      return;
    }
    let data = this.zernike.getUIColorMapData();
    let psfInfo = this.zernike.getPsfInfo();
    data.psfInfo = psfInfo;
    data.values = values;
    data.maxPeak = maxPeak;
    data.meanRms = meanRms;
    this.free();
    return data;
  }
  getIndexes() {
    let indexes = new Float64Array(66);
    indexes.fill(0);
    let params = window.zernikeParams.params;
    for (let i = 0; i < params.length; i++) {
      let state = isTrue(params[i].selected) && isTrue(params[i].enabled);
      indexes[i] = isTrue(state) ? 1 : 0;
    }
    return indexes;
  }
  free() {
    this.zernike.freeAberration();
  }
  genChart(buf0, buf90, w, h) {
    let canvas = document.createElement("canvas");
    canvas.width = w;
    canvas.height = h;
    canvas.style.visibility = "hidden";
    let cxt = canvas.getContext("2d");
    cxt.fillStyle = "white";
    cxt.fillRect(0, 0, w, h);
    cxt.font = "12pt Arial";
    // 绘制轴
    cxt.strokeStyle = "rgba(0,0,0,0.4)";
    cxt.fillStyle = "black";
    let padding = { top: 20, left: 40, right: 15, bottom: 30 };
    let axisX = { len: 60, interval: 10, num: 6 };
    let axisY = { len: 1, interval: 0.2, num: 5 };
    let real0 = [];
    let real90 = [];
    let real = {
      w: w - padding.left - padding.right,
      h: h - padding.top - padding.bottom
    };
    for (let i = 0; i <= 18; i++) {
      real0.push({ x: (i * real.w) / 18, y: -buf0[i] * real.h });
      real90.push({ x: (i * real.w) / 18, y: -buf90[i] * real.h });
    }
    cxt.translate(padding.left, h - padding.bottom);
    // 绘制X轴
    cxt.beginPath();
    let intervalLen = real.w / axisX.num;
    for (let i = 0; i <= axisX.num; i++) {
      let x = i * intervalLen;
      let str = i * axisX.interval + "";
      let txtW = cxt.measureText(str).width;
      cxt.moveTo(x, 0);
      cxt.lineTo(x, -real.h);
      cxt.fillText(str, x - txtW / 2, 22);
    }
    // 绘制Y轴
    let intervalLenY = real.h / axisY.num;
    for (let i = 0; i <= axisY.num; i++) {
      let y = -i * intervalLenY;
      let num = i * axisY.interval;
      num = parseInt(num * 10) / 10;
      let str = num + "";
      let txtW = cxt.measureText(str).width;
      cxt.moveTo(0, y);
      cxt.lineTo(real.w, y);
      cxt.fillText(str, -txtW - 5, y + 8);
    }
    cxt.stroke();
    // 绘制数据
    cxt.strokeStyle = "red";
    cxt.fillStyle = "red";
    this.drawSmoothLine(cxt, real0);
    this.drawLegend(cxt, real.w, real.h, intervalLen, 0, "0°");
    cxt.strokeStyle = "green";
    cxt.fillStyle = "green";
    this.drawSmoothLine(cxt, real90);
    this.drawLegend(cxt, real.w, real.h, intervalLen, 1, "90°");
    cxt.translate(padding.left, h - padding.bottom);
    return canvas.toDataURL("image/jpg");
  }
  drawLegend(cxt, realW, realH, intervalLen, num, txt) {
    let legendLoc = {
      x: realW - intervalLen + 2,
      y: -(realH - 20),
      offsetX: 10,
      offsetY: 30,
      lineLen: 30,
      circleR: 6
    };
    legendLoc.y += legendLoc.offsetY * num;
    cxt.beginPath();
    cxt.moveTo(legendLoc.x, legendLoc.y);
    cxt.lineTo(legendLoc.x + legendLoc.lineLen, legendLoc.y);
    cxt.arc(
      legendLoc.x + legendLoc.lineLen / 2,
      legendLoc.y,
      legendLoc.circleR,
      0,
      Math.PI * 2,
      true
    );
    cxt.fill();
    cxt.stroke();
    cxt.fillStyle = "black";
    cxt.fillText(txt, legendLoc.x + legendLoc.lineLen + legendLoc.offsetX, legendLoc.y + 6);
  }
  /**
   * 绘制平滑曲线
   *
   * @param {*} cxt
   * @param {*} points
   * @memberof GenReportMap
   */
  drawSmoothLine(cxt, points) {
    cxt.beginPath();
    let tmpArr = [];
    for (let i = 0; i < points.length; i++) {
      tmpArr.push(points[i].x);
      tmpArr.push(points[i].y);
    }
    var i = 0;
    var len = points.length;
    while (i < len) {
      i += drawSegment(cxt, tmpArr, i, len, len, 1, 0.5, null, false) + 1;
    }
    // drawSegment(cxt, tmpArr, 0, tmpArr.length, tmpArr.length, 1, 0, 'y', true)
    cxt.stroke();
  }

  drawSmoothLineOld(cxt, points) {
    cxt.beginPath();
    cxt.moveTo(points[0].x, points[0].y);
    cxt.lineTo(points[1].x, points[1].y);
    let beginPoint = points[2];
    for (let i = 2; i < points.length; i++) {
      let controlPoint = points[i - 2];
      let endPoint = {
        x: (controlPoint.x + points[i - 1].x) / 2,
        y: (controlPoint.y + points[i - 1].y) / 2
      };
      if (i === points.length - 1) {
        endPoint = points[i];
      }
      cxt.moveTo(beginPoint.x, beginPoint.y);
      cxt.quadraticCurveTo(controlPoint.x, controlPoint.y, endPoint.x, endPoint.y);
      beginPoint = endPoint;
    }
    cxt.stroke();
  }
}



// WEBPACK FOOTER //
// ./src/topography/js/GenReportMap.js